import { I18n } from '@calendly/i18n';
import { ArrowRightIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText, HeadlineText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "co8sjex";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const helpCenterLinkCss = "hby62uf";
const HelpCenterLink = forwardRef((props, ref) => {
  const href = 'https://calendly.com/learn/administrators';
  const target = '_blank';
  const rel = 'noopener noreferrer';
  const underline = false;
  return <Link ref={ref} {...props} href={href} target={target} rel={rel} underline={underline} className={classNames(helpCenterLinkCss, props.className)} />;
});
export const Recommended = () => <Container>
    <HeadlineText>
      {I18n.t('publisher.admin.dashboard.section.recommended.help_center_banner.title')}
    </HeadlineText>
    <BodyText>
      {I18n.t('publisher.admin.dashboard.section.recommended.help_center_banner.description')}
    </BodyText>
    <HelpCenterLink>
      {I18n.t('publisher.admin.dashboard.section.recommended.help_center_banner.link_text')}
      <ArrowRightIcon />
    </HelpCenterLink>
  </Container>;

require("./recommended.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./recommended.js");